import React, { useState } from "react";
import ReactDOM from "react-dom";
import ExpandableText from "../ExpandableText/ExpandableText";
import { productCardConfig } from "./ProductCard.config";
import "./ProductCard.scss";

/**
 *
 * @param {Object} props
 * @param {string} props.image
 * @param {string} props.title
 * @param {string} [props.edition]
 * @param {string} [props.description]
 * @param {string|number} [props.year]
 * @param {string[]} [props.sizes]
 * @param {string} [props.priceLabel]
 * @param {boolean} [props.handSigned]
 * @param {string} [props.ctaLabel]
 * @param {() => void} [props.onCtaClick]
 * @param {() => void} [props.onCardClick]
 */
const ProductCard = ({
  image,
  title,
  edition = "",
  description = "",
  year = "",
  sizes = [],
  priceLabel = "",
  handSigned = false,
  ctaLabel = "Purchase",
  onCtaClick,
  onCardClick,
}) => {
  const [showFullImage, setShowFullImage] = useState(false);

  return (
    <article className="ProductCard">
      <button
        type="button"
        className="ProductCard-imageButton"
        onClick={() => {
          setShowFullImage(true);
          onCardClick && onCardClick();
        }}
        aria-label={`View ${title}`}
      >
        <img src={image} alt={title} className="ProductCard-image" />
      </button>

      <div className="ProductCard-details">
        <div className="ProductCard-header" onClick={onCardClick}>
          <h4 className="ProductCard-name">{title}</h4>
          {edition && (
            <span className="ProductCard-edition">
              {edition}
              {handSigned && " / Hand-signed and numbered by the artist"}
            </span>
          )}
        </div>

        <ExpandableText
          text={description}
          maxLength={productCardConfig.descriptionMaxLength}
          className="ProductCard-description"
          toggleClassName="ProductCard-readMore"
        />

        <div className="ProductCard-meta">
          {year && (
            <div className="ProductCard-metaItem">
              <span className="ProductCard-metaLabel">Year</span>
              <span className="ProductCard-metaValue year">
                {year} <span className="ProductCard-span">|</span>
              </span>
            </div>
          )}

          {sizes.length > 0 && (
            <div className="ProductCard-metaItem">
              <span className="ProductCard-metaLabel">Sizes</span>
              <div className="ProductCard-sizes-div">
                <span className="ProductCard-sizes">
                  {sizes.map((size) => (
                    <span className="ProductCard-sizeTag" key={size}>
                      {size}
                    </span>
                  ))}
                </span>
                <span className="ProductCard-span">|</span>
              </div>
            </div>
          )}

          {priceLabel && (
            <div className="ProductCard-metaItem ProductCard-metaItem--price">
              <span className="ProductCard-metaLabel">Price</span>
              <span className="ProductCard-metaValue">{priceLabel}</span>
            </div>
          )}
        </div>

        <button type="button" className="ProductCard-cta" onClick={onCtaClick}>
          {ctaLabel}
        </button>
      </div>

      {showFullImage &&
        ReactDOM.createPortal(
          <div
            className="ProductCard-fullImageOverlay"
            onClick={() => setShowFullImage(false)}
          >
            <div
              className="ProductCard-fullImageContainer"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                type="button"
                className="ProductCard-fullImageClose"
                onClick={() => setShowFullImage(false)}
                aria-label="Close"
              >
                ×
              </button>
              <img src={image} alt={title} className="ProductCard-fullImage" />
            </div>
          </div>,
          document.body,
        )}
    </article>
  );
};

export default ProductCard;
